import {mapState} from "vuex";
import {debounce} from 'lodash';
import moment from "moment";

export const commonListMixin = {
    data() {
        return {
            formData: {},
            form: false,
            valid: false,
            errors: [],
            searchQuery: "",
            pagination: {
                itemsPerPage: 25,
            },
            footerProps: {
                'items-per-page-options': [10, 25, 50,100,300,500,700,1000, {text: 'All', 'value': -1}]
            },
            stateName: 'CommonList',
            commonState: null
        }
    },
    computed: {
        ...mapState({
            loading(state, getters) {
                return getters[`${this.stateName}/loading`]
            },
            totalNumber(state, getters) {
                return getters[`${this.stateName}/totalNumber`]
            },
            serverPagination(state, getters) {
                return getters[`${this.stateName}/serverPagination`]
            }
        }),
        modelData: {
            get() {
                return {};
            },
            set(value) {
                this.$store.commit(`${this.stateName}/setModelData`, value);
            }
        },
        query: {
            get() {
                return this.$store.state[this.stateName].query;
            },
            set(value) {
                this.$store.commit(`${this.stateName}/setQuery`, value);
            }
        },
        filters: {
            get() {
                return this.$store.state[this.stateName].filters;
            },
            set(value) {
                this.$store.commit(`${this.stateName}//setFilters`, value);
            }
        }
    },
    methods: {
        create(data) {
            return this.$store.dispatch(`${this.stateName}/create`, data)
        },
        resetState() {
            return this.$store.commit(`${this.stateName}/resetState`)
        },
        getAll() {
            return this.$store.dispatch(`${this.stateName}/getAll`)
        },
        delete(data) {
            return this.$store.dispatch(`${this.stateName}/delete`, data)
        },
        handleFilterChange: debounce(function () {
            this.getAll();
        }, 1000),
        async destroy(item, message, text = "Do you really want to delete?") {
            await this.$dialog.confirm({
                text: text,
                title: "Warning",
                actions: {
                    false: "No",
                    true: {
                        color: "red",
                        text: "Yes",
                        handle: () => {
                            this.delete([item.id])
                                .then(() => {
                                    this.getAll();
                                    this.$store.commit('Notification/showSuccess', message)
                                })
                                .catch(error => {
                                    console.error(error);
                                    this.$store.commit('Notification/showError', error.response.data.message)
                                });
                        }
                    }
                }
            });
        },
        save(messageName, resetFormData = {}) {
            return new Promise((resolve, reject) => {
                this.create()
                    .then(() => {
                        this.form = false;
                        this.getAll();
                        this.errors = null;
                        if (this.formData.id === undefined) {
                            this.$store.commit("Notification/showSuccess", messageName + ' created successfully');
                        } else {
                            this.$store.commit("Notification/showSuccess", messageName + ' updated successfully');
                        }
                        this.formData = resetFormData;
                        resolve(true)
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                        reject(error)
                    });
            })
        },
        showAddDialog() {

            if (this.$refs.formRef)
                this.$refs.formRef.reset();
            this.editing = false;

            this.errors = null;
            this.formData = {};
            this.form = true;
        },
        close() {
            this.form = false;
            this.errors = [];
            this.formData = {};
        },
        getCurrentYear() {
            let currentYear = moment().format('YYYY')
            return parseInt(currentYear);
        },
        getCurrentYearsubtwo() {
            let currentYear = Number(new Date().toISOString().substr(0, 4))-10;
            return parseInt(currentYear);
        },
        getYearPreviousOrAfterCurrent(value) {
            let currentYear = new Date().toISOString().substr(0, 4);
            return parseInt(currentYear) + value;
        }
    },

    watch: {
        pagination: {
            handler() {
                this.$store.commit(`${this.stateName}/setServerPagination`, this.pagination);
                this.getAll();
            },
            deep: true
        },
        searchQuery: debounce(function () {
            this.query = this.searchQuery;
            this.getAll();
        }, 1000)
    },
    destroyed() {
        // this.resetState();
    },
};
